
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 25","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.839 22.418l6.829-2.355-.047-10.69-6.782 2.495zm-1.507 0v-10.55l-.613-.188a45.257 45.257 0 01-2.59 3.108.713.713 0 01-.565.283.713.713 0 01-.565-.283 46.978 46.978 0 01-3.203-4.003v8.996zm-3.768-20.91c-1.256 0-2.324.415-3.203 1.247-.879.832-1.318 1.845-1.318 3.038 0 .628.408 1.617 1.224 2.967.817 1.35 1.915 2.826 3.297 4.427 1.381-1.601 2.48-3.077 3.297-4.427.816-1.35 1.224-2.34 1.224-2.967 0-1.193-.44-2.206-1.318-3.038-.88-.832-1.947-1.248-3.203-1.248zM8.289 19.78V9.23L1.46 11.586l.047 10.69zM26.374 7.536c.189 0 .361.07.518.211a.696.696 0 01.236.542v11.774c0 .314-.086.597-.26.848-.172.251-.4.44-.682.565l-7.159 2.496a3.21 3.21 0 01-1.884 0l-8.1-2.872-8.007 2.967a.889.889 0 01-.282.047.758.758 0 01-.518-.212A.696.696 0 010 23.36V11.586c0-.314.086-.597.259-.848.173-.251.4-.44.683-.565l7.065-2.449c-.314-.785-.471-1.429-.471-1.931a5.55 5.55 0 01.8-2.896 5.796 5.796 0 012.19-2.12A6.118 6.118 0 0113.564 0c1.099 0 2.111.26 3.038.777a5.796 5.796 0 012.19 2.12c.534.894.8 1.868.8 2.92 0 1.051-.659 2.566-1.978 4.544l.471.189 8.007-2.967a.889.889 0 01.282-.047zm-11.68-1.508c0 .314-.11.581-.33.801-.22.22-.486.33-.8.33-.314 0-.58-.11-.8-.33a1.09 1.09 0 01-.33-.8c0-.315.11-.581.33-.801.22-.22.486-.33.8-.33.314 0 .58.11.8.33.22.22.33.486.33.8z"}})])
          )
        }
      }
    